import { useQuery } from "@tanstack/react-query";
import { CampaignService } from "../services/BillingBrand.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BackednResponse } from "@shared/lib/types";
import { IGetBrandBilling } from "@shared/lib/types/brandBilling";
import { BILLING_BRAND_LIST_QUERY_KEY } from "../constants";

export function useGetBrandsBilling(
  searchQuery?: string,
  linkedBrands?: string[],
  limit?: number,
  pageNo?: number
) {
  const { data, isLoading, isError, error, isFetching } = useQuery<
    BackednResponse<IGetBrandBilling>
  >({
    queryKey: [
      ...BILLING_BRAND_LIST_QUERY_KEY,
      searchQuery,
      linkedBrands,
      limit,
      pageNo,
    ],
    queryFn: () =>
      CampaignService.getBrandsBilling(
        searchQuery,
        linkedBrands,
        limit,
        pageNo
      ),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brandsBilling: data?.data,
    isError,
    isFetching: isLoading,
    isFetchingOrig: isFetching,
  };
}
